export const SET_DRAWER_NAVIGATION_MODE = 'SET_DRAWER_NAVIGATION_MODE'
export const SELECT_DRAWER_NAVIGATION_OPTION = 'SELECT_DRAWER_NAVIGATION_OPTION'
export const CLEAR_DRAWER_NAVIGATION = 'CLEAR_DRAWER_NAVIGATION'
export const CLEAR_DRAWER_NAVIGATION_SUBMENU = 'CLEAR_DRAWER_NAVIGATION_SUBMENU'
export const SET_DRAWER_NAVIGATION_SUBMENU = 'SET_DRAWER_NAVIGATION_SUBMENU'